import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-880310da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-min-h-[50px] tw-justify-center tw-items-center tw-gap-[25px]" }
const _hoisted_2 = { class: "assessment-topic-title" }

import { routers } from "@/utils/constants";
import type {
  IAssessmentDetail,
  IChecklistInfoDetail,
} from "@/interfaces/assessments/IAssessmentDetails";

/** components */
import IconRight from "@/components/common/globalSearch/menuSearch/iconChevronRight.vue";
import AssessmentChecklistStatusTag from "@/components/assessment/assessmentChecklistStatusTag.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentTopic',
  props: {
    data: {}
  },
  emits: ["close-menu"],
  setup(__props: any, { emit }) {





return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: `${_unref(routers).assessChecklist}?checklistId=${_ctx.data?.checklistId}`,
    class: "tw-flex tw-w-full tw-items-center tw-justify-between tw-cursor-pointer !tw-no-underline",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('close-menu')), ["stop"]))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.data?.checklistName), 1),
        _createVNode(AssessmentChecklistStatusTag, {
          "checklist-status": _ctx.data?.checklistStatus,
          "checklist-status-id": _ctx.data?.checklistStatusId,
          "is-loading": false
        }, null, 8, ["checklist-status", "checklist-status-id"])
      ]),
      _createVNode(IconRight)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})